/** React Router's URL path */
export const PATH = '/project_profit_sheet_report'

/** title on the layout header */
export const HEADER = 'Project Profit Sheet Report'

/** module's redux state name */
export const REDUCER_NAME = 'pps_report'

export const MODULE = {
  RESET: `${REDUCER_NAME}/MODULE.RESET`,
}

export const GET_REPORT = {
  REQUEST: `${REDUCER_NAME}/GET_REPORT.REQUEST`,
  SUCCESS: `${REDUCER_NAME}/GET_REPORT.SUCCESS`,
  FAILURE: `${REDUCER_NAME}/GET_REPORT.FAILURE`,
}

export const DATE = {
  SET_FIELD: `${REDUCER_NAME}/DATE.SET_FIELD`,
}

export const GP = {
  SET: `${REDUCER_NAME}/GP.SET`,
}

export const VALUE = {
  SET: `${REDUCER_NAME}/VALUE.SET`,
}

export const FILTER = {
  SET_FIELD: `${REDUCER_NAME}/FILTER.SET_FIELD`,
}

export const SORT = {
  SET_FIELD: `${REDUCER_NAME}/SORT.SET_FIELD`,
}



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/constants.js